import React from "react";
import {
  FaVideo,
  FaPen,
  FaRobot,
  FaCalendarAlt,
  FaHandshake,
  FaCheckCircle,
  FaLock,
  FaPlayCircle,
  FaHourglassHalf,
} from "react-icons/fa";

// 🔹 Icon by content type
const getIcon = (type) => {
  switch (type) {
    case "video":
      return <FaVideo className="text-[#ED254E]" />;
    case "widget":
      return <FaPen className="text-[#5EB1BF]" />;
    case "ai":
      return <FaRobot className="text-[#5EB1BF]" />;
    case "human_coach":
      return <FaCalendarAlt className="text-[#A93F55]" />;
    case "accountability":
      return <FaHandshake className="text-[#F9DC5C]" />;
    default:
      return <span>•</span>;
  }
};

// 🔹 Status icon
const getStatusBadge = (status) => {
  switch (status) {
    case "completed":
      return <FaCheckCircle className="text-[#22C55E] ml-auto" />;
    case "in_progress":
      return <FaHourglassHalf className="text-yellow-500 ml-auto" />;
    default:
      return <FaPlayCircle className="text-gray-400 ml-auto" />;
  }
};

// const Subsection = ({ subsections = [], onSelectSubsection, isUnlocked = true, moduleOrder = 1 }) => {
const Subsection = ({
  subsections = [],
  onSelectSubsection = () => {},
  isUnlocked = true,
  moduleOrder = 1,
  completedSubs,
}) => {
  if (!subsections.length) {
    return <p className="text-gray-400">No subsections available</p>;
  }

  // 🔹 Group subsections by section name
  const grouped = subsections.reduce((acc, sub) => {
    const section = sub.section || sub.section_title || "Other";
    if (!acc[section]) acc[section] = [];
    acc[section].push(sub);
    return acc;
  }, {});

  const sectionNames = Object.keys(grouped);

  return (
    <div className="space-y-6">
      {sectionNames.map((sectionName, sectionIndex) => {
        const subs = grouped[sectionName];
        const sectionNumber = `${moduleOrder}.${sectionIndex + 1}`;

        return (
          <div key={sectionName} className="mb-2">
            {/* Section Heading */}
            <h3 className="text-[#5EB1BF] font-semibold text-lg mb-3">
              {sectionNumber} {sectionName}
            </h3>

            {/* Subsection Items */}
            <ul className="space-y-2 ml-1">
              {subs.map((sub) => {
                const isCompleted =
                  sub.status === "completed" ||
                  sub.completed === true ||
                  completedSubs?.[sub.id] === true;
                const statusForBadge = isCompleted ? "completed" : sub.status;

                return (
                  <li
                    key={sub.id}
                    className={`flex items-center gap-3 py-1.5 pl-1 pr-2 rounded-md font-gotham text-[15px] transition-colors
                      ${
                        isUnlocked
                          ? "cursor-pointer hover:bg-gray-50"
                          : "opacity-50 cursor-not-allowed"
                      }
                    `}
                    onClick={() => isUnlocked && onSelectSubsection(sub)}
                    title={
                      isUnlocked
                        ? ""
                        : "Complete previous modules to unlock this module."
                    }
                  >
                    {/* Icon */}
                    {getIcon(sub.type)}

                    {/* Title */}
                    <span
                      className={`font-medium ${
                        isCompleted ? "text-gray-700" : "text-gray-800"
                      }`}
                    >
                      {sub.title}
                    </span>

                    {/* Status Icon */}
                    {getStatusBadge(statusForBadge)}

                    {/* Lock Icon if locked */}
                    {!isUnlocked && <FaLock className="text-gray-400 ml-2" />}
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default Subsection;
